import {Injectable} from "@angular/core";
import {HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Observable} from "rxjs";
import {TokenStorageService} from "../_services/token-storage.service";

const  TOKEN_HEADER_KEY = 'Authorization';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor (private token: TokenStorageService) {}
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable <HttpEvent<any>> {
    let authReq = req;
    let token = this.token.getToken();
    if (token == 'undefined') {
      token = this.token.getUser().token;
    }

    if (token != null){
      // FormData (file uploads / multipart) must NOT have Content-Type forced to JSON,
      // otherwise the browser can't set the multipart boundary and the server fails to
      // parse form parameters (e.g. itemData on /item-listings).
      const isFormData = req.body instanceof FormData;
      if (req.url.endsWith("upload") || isFormData) {
        authReq = req.clone({
          setHeaders: {
            'Authorization': 'Bearer ' + token
          },
        });
      } else if (req.method === 'GET' || req.method === 'HEAD' || req.method === 'OPTIONS') {
        // Do not force Content-Type on body-less requests (can trigger odd CORS/preflight).
        authReq = req.clone({
          setHeaders: {
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
          },
        });
      } else {
        authReq = req.clone({
          setHeaders: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
          },
        });
      }
    }
    return next.handle(authReq);
  }
}

export const authInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
];
